import React from "react";
import { useTranslation } from 'react-i18next';
import Icon from '../../ui/icon/icon';
import { TicketCard } from "../ticketCard/ticketCard";


export function NewHolderEmail({email, status}) {
    const { t } = useTranslation();
    if (!email) {
        return null;
    }

    return (
        <div className='neo-item-card-new-holder-email-container'>
            <span><Icon name='paperPlane'/></span>
            <span>
                {status === 'warning' ? t('widget.ticket.pending-transfer') : t('widget.ticket.ticket-transfered')}
                ({email})
            </span>
        </div>
    )
}

export default function TicketTransferCard({config, onSubmit = () => {}, withMargin}) {

    const transferStatus = React.useMemo(() => {
        switch (config.transfer_status) {
        case "validated":
            return "error";
        case "pending":
            return "warning";
        default:
            return "default";
        }
    }, [config]);

    return <TicketCard ticket={config.ticket_transfer_card || config} onSubmit={onSubmit} cardStatus={transferStatus} withMargin={withMargin} content={<NewHolderEmail email={config.transfer_email} status={transferStatus}/>}/>
}
